var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-12 lbv-leak-free-days" },
      [
        _c("b-card", { attrs: { header: "Leak-Free Days" } }, [
          _c("table", { staticClass: "table b-table" }, [
            _c("thead", [
              _c("th", [_vm._v("Leak Free Days")]),
              _vm._v(" "),
              _c("th", [_vm._v("Fix Leak Days")]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.pagedCycles, function (item, index) {
                return _c("tr", [
                  _c("td", [
                    _c(
                      "table",
                      { staticClass: "table b-table table-striped" },
                      [
                        _c("thead", [
                          _c("th", [_vm._v("Start Date")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Days")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Paused")]),
                        ]),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(item.leakFreeDate))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.leakFreeDays))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.paused))]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "table",
                      { staticClass: "table b-table table-striped" },
                      [
                        _c("thead", [
                          _c("th", [_vm._v("Start Date")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Days Remaining")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Elapsed Days")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(item.fixDays, function (fixDay, index) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(fixDay.created))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(fixDay.remaining))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(fixDay.elapsed))]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _vm.hasNextPage || _vm.pageNumber > 1
            ? _c(
                "div",
                { staticClass: "pagination col-lg-12" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "page prev",
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled: _vm.pageNumber === 1,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.page.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n          Prev\n        ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "current-page" }, [
                    _vm._v(
                      "\n          Page: " +
                        _vm._s(_vm.pageNumber) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "page next",
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled: !_vm.hasNextPage,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.page.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n          Next\n        ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }